import { RoleResponse } from '@/api/roles/types';
import { Validators } from '@components/Form/FormItem/FormItemValidation';
import { IFormItem } from '@components/Form/FormItem/FormItem';

export const createRegionOrgModalSchema = (
  allOrganizations: any,
  allRoles: RoleResponse[],
) =>
  [
    {
      key: 'parentId',
      label: 'Областной уровень',
      type: 'select',
      payload: {
        options: allOrganizations,
        fieldNames: {
          label: 'shortName',
          value: 'id',
        },
      },
      disabled: true,
      validation: [Validators.required()],
    },
    {
      key: 'name',
      label: 'Полное название',
      type: 'text',
      placeholder: 'Введите название',
      validation: [Validators.required()],
    },
    {
      key: 'shortName',
      label: 'Краткое название',
      type: 'text',
      placeholder: 'Введите название',
      validation: [Validators.required()],
    },
    {
      key: 'roleNames',
      label: 'Роли в организации',
      type: 'select',
      payload: {
        options: allRoles,
        mode: 'multiple',
        fieldNames: {
          label: 'description',
          value: 'name',
        },
      },
      validation: [Validators.required()],
    },
  ] as IFormItem[];
